import React from "react";
import styled from "styled-components";
import { Configuration } from "../../context/ConfigurationContext";
import LeftLogo from "../LeftLogo";
import RightLogo from "../RightLogo";
import AdditionalInformation from "./AdditionalInformation";
import BattersBox from "./BattersBox";
import PitchCall from "./PitchCall";
import StrikeZone from "./StrikeZone";

export const Overlay = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const Spacer = styled.div`
  flex-grow: 1;
`;

type FullViewProps = {
  config: Configuration;
};

const SHOW_TMOB = process.env.SHOW_TMOB === "true";

const FullView: React.FC<FullViewProps> = ({ config }) => (
  <Overlay>
    <StrikeZone config={config} />
    <LeftLogo config={config} />
    {SHOW_TMOB && <RightLogo config={config} />}
    <PitchCall config={config} />
    <Spacer />
    <BattersBox config={config} />
    {!!config.display.displayAddtlInfo ? <AdditionalInformation config={config} /> : null}
  </Overlay>
);

export default FullView;
